import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  CopyAdditionalServiceRulesToSeasonsRequest,
  CopyCheckInCheckOutTimesToSeasonsRequest,
  CopyLastMinuteRuleToSeasonsRequest,
  CopyMinimumLengthOfStayRuleToSeasonsRequest,
  CopyPreparationRestrictionRuleToSeasonsRequest,
  CopyPriceChangeRuleToSeasonsRequest,
  CopyPricesToSeasonsRequest,
  CopyReleaseIntervalRuleToSeasonsRequest,
  CopyShortStayRuleToSeasonsRequest,
  CopyWeekdayCheckInAndCheckOutRulesToSeasonsRequest,
  CopyWeekdayCheckInCheckOutTimeRulesToSeasonsRequest,
  CopyWeekdayMinimumStayRulesToSeasonsRequest,
  CopyWeekdayPriceChangeRulesToSeasonsRequest,
  DeleteRulesFromSeasonsRequest,
} from '../../features/defaultRateTools/defaultRateToolsSlice';

const defaultRateToolsService = {
  copyPreparationRestrictionRuleToSeasons: async (
    data: CopyPreparationRestrictionRuleToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRatePreparationRestrictionRuleToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyMinimumLengthOfStayRuleToSeasons: async (
    data: CopyMinimumLengthOfStayRuleToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateMinimumLengthOfStayRuleToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyShortStayRuleToSeasons: async (
    data: CopyShortStayRuleToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateShortStayRuleToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyLastMinuteRuleToSeasons: async (
    data: CopyLastMinuteRuleToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateLastMinuteRuleToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyPriceChangeRuleToSeasons: async (
    data: CopyPriceChangeRuleToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRatePriceChangeRuleToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyReleaseIntervalRuleToSeasons: async (
    data: CopyReleaseIntervalRuleToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateReleaseIntervalRuleToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyWeekdayCheckInAndCheckOutRules: async (
    data: CopyWeekdayCheckInAndCheckOutRulesToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateWeekdayCheckInAndCheckOutRulesToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyWeekdayMinimumStayRules: async (
    data: CopyWeekdayMinimumStayRulesToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateWeekdayMinimumStayRulesToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyWeekdayPriceChangeRules: async (
    data: CopyWeekdayPriceChangeRulesToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateWeekdayPriceChangeRulesToSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  copyWeekdayCheckInCheckOutTimeRules: async (
    data: CopyWeekdayCheckInCheckOutTimeRulesToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateWeekdayCheckInCheckOutTimes',
      data,
      config,
    );
    return response.data;
  },
  copyCheckInCheckOutTimes: async (
    data: CopyCheckInCheckOutTimesToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateCheckInCheckOutTimes',
      data,
      config,
    );
    return response.data;
  },
  copyAdditionalServiceRules: async (
    data: CopyAdditionalServiceRulesToSeasonsRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    console.log('copyAdditionalServiceRules data', data);

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRateAdditionalServiceRules',
      data,
      config,
    );
    return response.data;
  },
  copyPrices: async (data: CopyPricesToSeasonsRequest) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copyDefaultRatePrices',
      data,
      config,
    );
    return response.data;
  },
  deleteRulesFromSeasons: async (data: DeleteRulesFromSeasonsRequest) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/deleteRulesFromSeasonRates',
      data,
      config,
    );
    return response.data;
  },
};

export default defaultRateToolsService;
